import './Home.css';
import homepageVideo1 from '../../assets/videos/homepage/homepage_video_1.mp4';
import homepageVideo2 from '../../assets/videos/homepage/homepage_video_2.mp4';
import model1 from '../../assets/images/homepage/model_1.jpeg';
import model2 from '../../assets/images/homepage/model_2.jpeg';
import model3 from '../../assets/images/homepage/model_3.jpeg';
import model5 from '../../assets/images/homepage/model_5.jpeg';
import model6 from '../../assets/images/homepage/model_6.jpeg';
import model7 from '../../assets/images/homepage/model_7.jpeg';
import model8 from '../../assets/images/homepage/model_8.jpeg';
import model9 from '../../assets/images/homepage/model_9.jpeg';
import model10 from '../../assets/images/homepage/model_10.jpeg';
import model11 from '../../assets/images/homepage/model_11.jpeg';
import model12 from '../../assets/images/homepage/model_12.jpeg';
import model13 from '../../assets/images/homepage/model_13.jpeg';

const HomePage = () => {
  return (
    <div className="rt-home">
      <section className="rt-hero fade-up">
        <div className="rt-hero-bg">
          <img src={model3} alt="" aria-hidden="true" />
          <div className="rt-hero-overlay" />
        </div>
        <div className="rt-hero-content">
          <span className="eyebrow">SRK Production</span>
          <h1>Welcome to<br /><em>SRK Production</em></h1>
          <span className="rt-hero-tagline">Talent &amp; Entertainment Platform</span>
          <button type="button" className="hero-cta">
            Explore Now
          </button>
        </div>
        <div className="rt-hero-figures">
          <div className="hero-image-small fade-down">
            <img src={model2} alt="SRK Production model on stage" />
          </div>
          <div className="hero-image-large fade-up">
            <img src={model3} alt="SRK Production model on stage" />
          </div>
        </div>
      </section>

      <div className="rt-divider" />

      <section className="feature-panel-wrapper fade-up">
        <div className="feature-panel-inner">
          <div className="feature-panel">
            <div className="feature-inner">
              <div className="feature-copy">
                <span className="eyebrow">Our Mission</span>
                <h2>Where Talent Meets Opportunity</h2>
                <p>
                  At SRK Production, we believe that every individual has the potential to shine. Our mission is to discover, nurture, and promote talented people by providing them with a professional platform to showcase their abilities in the entertainment and fashion industries.
                </p>
              </div>
              <div className="feature-visual">
                <video
                  src={homepageVideo1}
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fade-up w-100">
        <div className="feature-panel-inner">
          <div className="feature-panel">
            <div className="feature-inner">
              <div className="feature-visual">
                <img src={model13} alt="SRK Production feature" />
              </div>
              <div className="feature-copy">
                <span className="eyebrow">Our Heritage</span>
                <h2>Who We Are?</h2>
                <p>
                  SRK Production is a talent promotion and entertainment company dedicated to creating opportunities for aspiring artists, models, actors, performers, and creative individuals. We work closely with industry professionals and collaborate with various production houses to help talented individuals build successful careers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="rt-divider" />

      <section className="feature-panel-wrapper fade-up">
        <div className="feature-panel-inner">
          <div className="feature-panel">
            <div className="feature-inner">
              <div className="feature-copy">
                <span className="eyebrow">What We Offer</span>
                <h2>Platforms For Every Stage</h2>
                <p>
                  We provide a platform for common people to showcase their talent and gain exposure in the entertainment industry. Fashion &amp; Modeling Opportunities selected models are promoted as Show Stoppers in fashion and modeling events, helping them gain recognition and industry experience.
                </p>
                <ul>
                  <li>Side Actor Roles</li>
                  <li>Co-Actor Roles</li>
                  <li>Main Lead Roles</li>
                  <li>Second Lead Roles</li>
                  <li>Character Roles</li>
                  <li>Web Series Projects</li>
                  <li>Short Films</li>
                  <li>Music Videos</li>
                  <li>Television Projects</li>
                  <li>Brand Promotions</li>
                </ul>
              </div>
              <div className="feature-visual">
                <img src={model5} alt="SRK Production feature" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fade-up w-100">
        <div className="feature-panel-inner">
          <div className="rt-gallery">
            <span className="eyebrow rt-gallery-label">Faces of SRK Production</span>
            <div className="marquee-container">
              <div className="marquee-track">
                <div className="marquee-item"><img src={model6} alt="Model 6" /></div>
                <div className="marquee-item"><img src={model7} alt="Model 7" /></div>
                <div className="marquee-item"><img src={model8} alt="Model 8" /></div>
                <div className="marquee-item"><img src={model9} alt="Model 9" /></div>
                <div className="marquee-item"><img src={model10} alt="Model 10" /></div>
                <div className="marquee-item"><img src={model11} alt="Model 11" /></div>
                <div className="marquee-item"><img src={model12} alt="Model 12" /></div>
                <div className="marquee-item"><img src={model6} alt="Model 6" /></div>
                <div className="marquee-item"><img src={model7} alt="Model 7" /></div>
                <div className="marquee-item"><img src={model8} alt="Model 8" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="rt-divider" />

      <section className="feature-panel-wrapper fade-up">
        <div className="feature-panel-inner">
          <div className="feature-panel">
            <div className="feature-inner">
              <div className="feature-copy">
                <span className="eyebrow">Our Vision</span>
                <h2>Our Vision</h2>
                <p>
                  To become one of India's leading talent promotion platforms by connecting aspiring artists with genuine opportunities in acting, modeling, fashion, television, films, and digital entertainment.
                </p>
              </div>
              <div className="feature-visual">
                <video
                  src={homepageVideo2}
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fade-up w-100">
        <div className="feature-panel-inner">
          <div className="feature-panel">
            <div className="feature-inner">
              <div className="feature-visual">
                <img src={model1} alt="SRK Production feature" />
              </div>
              <div className="feature-copy">
                <span className="eyebrow">Our Mission</span>
                <h2>Our Mission</h2>
                <ul>
                  <li>Discover hidden talent across India.</li>
                  <li>Provide professional exposure and guidance.</li>
                  <li>Create opportunities through auditions and events.</li>
                  <li>Support aspiring artists in building successful careers.</li>
                  <li>Connect talent with production houses and industry professionals.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="rt-divider" />

      <section className="feature-panel-wrapper fade-up">
        <div className="feature-panel-inner">
          <div className="feature-panel">
            <div className="feature-inner">
              <div className="feature-copy">
                <span className="eyebrow">Why SRK Production</span>
                <h2>Why Choose SRK Production?</h2>
                <ul className="checkmark-list">
                  <li>Professional Platform for New Talent</li>
                  <li>Fashion Show Opportunities</li>
                  <li>Acting &amp; Modeling Exposure</li>
                  <li>Industry Networking</li>
                  <li>Collaboration with Production Houses</li>
                  <li>Career Growth Opportunities</li>
                  <li>Talent Development Programs</li>
                </ul>
              </div>
              <div className="feature-visual">
                <img src={model5} alt="SRK Production feature" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="final-panel fade-up">
        <div className="join-block text-center">
          <span className="eyebrow">Get Started</span>
          <h3>Join SRK Production Today</h3>
          <p>
            Whether you dream of becoming a model, actor, performer, or entertainment professional, SRK Production is committed to helping you take the next step toward your career goals.
          </p>
          <p className="final-line">Your Talent, Our Platform, Unlimited Possibilities.</p>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
